// In a new file, e.g., src/api/axios.js
import axios from 'axios';

// Determine the base URL based on environment
const getBaseURL = () => {
  return process.env.REACT_APP_API_BASE_URL
};

const api = axios.create({
  baseURL: getBaseURL(),
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    // Get the token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists, add it to the headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;